import { render, staticRenderFns } from "./option-group.vue?vue&type=template&id=6df5061f"
import script from "./option-group.vue?vue&type=script&lang=js"
export * from "./option-group.vue?vue&type=script&lang=js"
import style0 from "./option-group.vue?vue&type=style&index=0&id=6df5061f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports